module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/omnichannel_schema-5c7d9199cd702e9f33a9161d4c768ba3.svg";